import { Location } from "@angular/common";
import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewContainerRef
} from "@angular/core";
import { Router } from "@angular/router";
import { overlayConfigFactory } from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import { TranslateService } from "ng2-translate/ng2-translate";
import {
    SendMoneyDetail,
    SendMoneySteps
} from "../../../models/sendmoney/sendmoney";
import { AboutUsComponent } from "../../../sharedcomponents/about-us/about-us.component";
import { AlertService } from "../../../sharedcomponents/commonservice/alert.service";
import { geolocation } from "../../../sharedcomponents/commonservice/geolocation/geoloc";
//declare var userprofile;
import { utilityService } from "../../../sharedcomponents/commonservice/utility.service";
import { SharepromotainalPopupComponent } from "../../../sharedcomponents/sharepromotionalcode/sharepromotainal-popup/sharepromotainal-popup.component";
import { TutorialComponent } from "../../../sharedcomponents/tutorial/tutorial.component";
import { AlertPopupComponent } from "../../../sharedcomponents/_directive/alert-popup/alert-popup.component";
import { DoNotRefreshAndBackComponent } from "../../../sharedcomponents/_directive/do-not-refresh-and-back/do-not-refresh-and-back.component";
import { InfoPopupComponent } from "../../../sharedcomponents/_directive/info-popup/info-popup.component";
import { messagecenterService } from "../../../_services/messagecenter/messagecenterservice";
import { SendMoneyService } from "../../../_services/sendmoneyservice/sendmoneyservice";
import { AuthService } from "../../../_services/userservice/auth.service";
import { UserStateService } from "../../../_services/userservice/userstateservice";
import { userlogoutservice } from "../../commonservice/logout/userlogout.service";
import { AppSettings } from "../../_common/constants/app.constants";

declare var ___MobileAgent___: any;

@Component({
    moduleId: module.id,
    selector: "headerMenu",
    templateUrl: "headerMenu.component.html",
    providers: [
        userlogoutservice,
        messagecenterService,
        AlertService,
        Modal,
        AuthService
    ]
})
export class headerMenuComponent implements OnInit, OnDestroy {
    headertext = "";
    username: string;
    cartItemCount: number;
    messageListCount = 0;
    isCartVisable = true;
    isMessaageCentertVisable = true;
    subModalpopup: any;
    isMenu = true;
    mobWidth: any;
    isBack = false;
    messageList: any = [];
    isBeingLinked;
    screenDetail: any = {};
    sendMoneyDetail: SendMoneyDetail;
    CountryCodeTo: string = "";
    @Input() isBackbutton: boolean;
    @Output() menuWindowResize: EventEmitter<String> = new EventEmitter<String>(); // creating an output event
    @Output() gobackMenu: EventEmitter<String> = new EventEmitter<String>(); // creating an output event
    //@HostListener('window:beforeunload', ['$event'])
    //doSomething($event) {
    // if user close browser through cross button , without login off from application
    // this.logOutService();
    //}
    @HostListener("window:resize", ["$event"])
    onResize(event) {
        this.verifyScreen(event.target.innerWidth);
    }
    verifyScreen(screenWidth) {
        if (
            this.screenDetail.screenWidth != undefined &&
            this.screenDetail.screenWidth < Number(AppSettings.MOBILE_SCREEN_WIDTH)
        ) {
            return;
        }
        this.screenDetail.screenWidth = screenWidth;
        if (screenWidth < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
            this.screenDetail.mobileScreen = true;
            this.screenDetail.showBothScreen = false;
            this.screenDetail.enableBackButton = true;
        } else {
            this.screenDetail.mobileScreen = false;
            this.screenDetail.showBothScreen = true;
            this.screenDetail.enableBackButton = false;
        }
        this.menuWindowResize.emit(this.screenDetail);
    }
    constructor(
        private router: Router,
        private auth: AuthService,
        private translate: TranslateService,
        private _logoutserv: userlogoutservice,
        private sendMoneyService: SendMoneyService,
        private _location: Location,
        public utilserv: utilityService,
        private alertService: AlertService,
        public geoloc: geolocation,
        private userStateService: UserStateService,
        public modal: Modal,
        private vcRef: ViewContainerRef
    ) {
        // following funtion will get lat long in every page load
        this.geoloc.getGioLocation();
        // set all master data here
        this.userStateService.getcurrentUserDetailData().subscribe(data => {
            this.CountryCodeTo = data.countryPreference;
        });

        if (this.utilserv.getObjectText(this.CountryCodeTo) == "") {
            if (sessionStorage.UserData != undefined) {
                let UserData = JSON.parse(
                    this.utilserv.AESDecrypt(sessionStorage.UserData)
                );
                this.auth.setUserDetails(UserData);
            }
        }

        const path = this.router.url.split("/")[1];
        if (
            path == "shoppingcart" ||
            path == "PaymentReceipt" ||
            path == "PaymentReceiptDebitcard"
        ) {
            this.isCartVisable = false;
        }
        if (path == "messagecenter") {
            this.isMessaageCentertVisable = false;
        }
        // if (path == 'repeatorder' || path == 'exchangerate' || path == 'sendmoney') {
        //   this.sendMoneyService.setPageFlow(path);
        //   sessionStorage.PageFlow = path;
        //   if (path == 'sendmoney') {
        //     sessionStorage.RepeatOrderFlow = '';
        //   }
        // }
        if (
            !(
                path == "repeatorder" ||
                path == "exchangerate" ||
                path == "addaccountdetail" ||
                path == "bankdetails" ||
                path == "payatstore" ||
                path == "agentdetails" ||
                path == "branches" ||
                path == "branchedetails" || // this is required for branch details called
                path == "sendmoneysummary" ||
                path == "sendmoney"
            )
        ) {
            this.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
        }
    }

    ngOnInit() {
        const path = this.router.url.split("/")[1];
        let filterpagetitle: any;
        // Verify Mobile Logic
        this.verifyScreen(window.screen.width);
        this.getCartCount();
        //  const elements: any = document.getElementById('footer');
        // elements.style.display = 'block';
        const userStateServiceSub = this.userStateService
            .getcurrentUserDetailData()
            .subscribe(data => {
                this.isBeingLinked = data.IsBeingLinked;
                this.username = data.firstName;
                if (userStateServiceSub !== undefined) {
                    userStateServiceSub.unsubscribe();
                }
            });

        this.utilserv.restGet(AppSettings.jsontitlefile, false).subscribe(data => {
            if (data == undefined) {
                return;
            }
            filterpagetitle = data.filter(item => item.routename === path);
            if (filterpagetitle.length > 0) {
                this.translate.use(sessionStorage.langCode).subscribe(data => {
                    console.log("Observer got a next value: " + data);
                    this.headertext = this.translate
                        .instant(filterpagetitle[0].pagetitle)
                        .toString();
                    if (
                        filterpagetitle[0].isBackButton == true ||
                        this.isBackbutton == true
                    ) {
                        this.isMenu = false;
                        this.isBack = true;
                    }
                });
            }
        });
    }

    sendMoneyClick() {
        const path = this.router.url.split("/")[1];
        if (path == "sendmoney") {
            return false;
        }

        const _self = this;
        if (!___MobileAgent___.IsWrapper() && (localStorage.isShowDoNotRefreshAndBack == false || localStorage.isShowDoNotRefreshAndBack == undefined ||
            localStorage.isShowDoNotRefreshAndBack == "false" || localStorage.isShowDoNotRefreshAndBack == "undefined")) {
            let modalData: any = {};
            modalData.Title = this.translate.instant("Common_lblInfo").toString();
            modalData.Message = this.translate
                .instant("Common_lblDoNotRefreshAndBack")
                .toString();
            modalData.Message1 = this.translate
                .instant("Common_lblDoNotRefreshAndBackCheck")
                .toString();
            if (this.modal.overlay.defaultViewContainer == undefined) {
                this.modal.overlay.defaultViewContainer = this.vcRef;
            }
            return this.modal
                .open(
                    DoNotRefreshAndBackComponent,
                    overlayConfigFactory({ modalData }, BSModalContext)
                )
                .then(function (obj) {
                    obj.onDestroy.subscribe(data => {
                        console.log("Observer got a next value: " + data);
                        localStorage.isShowDoNotRefreshAndBack =
                            modalData.isShowDoNotRefreshAndBack;
                        _self.utilserv.busy = _self.geoloc
                            .islocPermissionable()
                            .subscribe(data => {
                                if (data == undefined) {
                                    return;
                                }
                                if (data == true) {
                                    _self.sendMoneyDetail = new SendMoneyDetail();
                                    _self.sendMoneyDetail.isData = true;
                                    _self.sendMoneyService.setSendMoneyDetailDataBlank(
                                        _self.sendMoneyDetail
                                    );
                                    _self.sendMoneyService.setModalPopup(
                                        SendMoneySteps.PickupType
                                    );
                                    _self.router.navigate(["/sendmoney"]);
                                    return;
                                } else {
                                    let modalData: any = {};
                                    modalData.Action = _self.translate.instant("Common_lblOk");
                                    modalData.Title = _self.translate
                                        .instant("Common_lblInfo")
                                        .toString();
                                    modalData.Message = _self.translate
                                        .instant("Common_lblLocationValidate")
                                        .toString();
                                    _self.modal.overlay.defaultViewContainer = _self.vcRef;
                                    return _self.modal
                                        .open(
                                            AlertPopupComponent,
                                            overlayConfigFactory({ modalData }, BSModalContext)
                                        )
                                        .then(function (obj) {
                                            obj.onDestroy.subscribe(data => {
                                                console.log("Observer got a next value: " + data);
                                                _self.sendMoneyDetail = new SendMoneyDetail();
                                                _self.sendMoneyDetail.isData = true;
                                                _self.sendMoneyService.setSendMoneyDetailDataBlank(
                                                    _self.sendMoneyDetail
                                                );
                                                _self.sendMoneyService.setModalPopup(
                                                    SendMoneySteps.PickupType
                                                );
                                                _self.router.navigate(["/sendmoney"]);
                                                return;
                                            });
                                        });
                                }
                            });
                    });
                });
        } else {
            this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(data => {
                if (data == undefined) {
                    return;
                }
                if (data == true) {
                    _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                    _self.sendMoneyDetail = new SendMoneyDetail();
                    _self.sendMoneyDetail.isData = true;
                    _self.sendMoneyService.setSendMoneyDetailDataBlank(
                        _self.sendMoneyDetail
                    );
                    _self.router.navigate(["/sendmoney"]);
                    return;
                } else {
                    let modalData: any = {};
                    modalData.Action = _self.translate.instant("Common_lblOk");
                    modalData.Title = _self.translate
                        .instant("Common_lblInfo")
                        .toString();
                    modalData.Message = _self.translate
                        .instant("Common_lblLocationValidate")
                        .toString();
                    _self.modal.overlay.defaultViewContainer = _self.vcRef;
                    return _self.modal
                        .open(
                            AlertPopupComponent,
                            overlayConfigFactory({ modalData }, BSModalContext)
                        )
                        .then(function (obj) {
                            obj.onDestroy.subscribe(data => {
                                console.log("Observer got a next value: " + data);
                                _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                                _self.sendMoneyDetail = new SendMoneyDetail();
                                _self.sendMoneyDetail.isData = true;
                                _self.sendMoneyService.setSendMoneyDetailDataBlank(
                                    _self.sendMoneyDetail
                                );
                                _self.router.navigate(["/sendmoney"]);
                                return;
                            });
                        });
                }
            });
        }
    }
    goToHome() {
        this.router.navigate(["/dashboard"]);
        return;
    }
    agentLocatorClick() {
        // this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(data => {
        //   if (data == undefined) {
        //     return;
        //   }
        //   if (data == true) {
        //     this.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
        //     this.router.navigate(['/agentlocator']);
        //     return;
        //   } else {
        //     const _self = this;
        //     let modalData: any = {};
        //     modalData.Action = this.translate.instant('Common_lblOk');
        //     modalData.Title = this.translate.instant('Common_lblInfo').toString();
        //     modalData.Message = this.translate.instant('Common_lblLocationValidate').toString();
        //     this.modal.overlay.defaultViewContainer = this.vcRef;
        //     return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
        //       obj.onDestroy.subscribe(data => {
        //         _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
        //         _self.router.navigate(['/agentlocator']);
        //         return;
        //       });
        //     });
        //   }
        // });
        this.router.navigate(["/agentlocator"]);
    }

    logOutService() {
        // const elements: any = document.getElementById('footer');
        // elements.style.display = 'none';
        this.utilserv.busy = this._logoutserv.logout().subscribe(data => {
            let resJSON = data;
            if (resJSON.Envelope.Body.BaseResponse.StatusCode == 10000) {
                console.log("Observer got a next value: " + data);
                //sessionStorage.removeItem("KeyUID");
                sessionStorage.removeItem("T1");
                sessionStorage.removeItem("T2");
                this.router.navigate(["/login"]);
                return;
            } else if (resJSON.Envelope.Body.BaseResponse.StatusCode == 20001) {
                return false;
            } else {
                this.alertService.openErrorAlert(
                    this.translate.instant("Common_lblOops"),
                    this.translate.instant("Message_errorMessage")
                );
            }
        });
    }
    logOut() {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        const _self = this;
        const modalData: any = {};
        modalData.Title = _self.translate.instant("Common_lblConfirm");
        modalData.Message = _self.translate.instant("LogoutPopup_desc");
        return _self.modal
            .open(
                InfoPopupComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    console.log("Observer got a next value: " + data);
                    if (modalData.next == "yes") {
                        _self.logOutService();
                    }
                });
            });
    }
    getCartCount() {
        this.sendMoneyService.getcurrentcartDetailData().subscribe(data => {
            this.cartItemCount = data.ItemCount;
            this.messageListCount = data.UnReadMessageCount;
        });
    }
    cartClick() {
        if (this.cartItemCount > 0) {
            this.router.navigate(["/shoppingcart"]);
            return;
        } else {
            // this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('Common_lblCartEmpty'));
            this.modal.overlay.defaultViewContainer = this.vcRef;
            this.alertService.openErrorAlert(
                this.translate.instant("Common_lblInfo"),
                this.translate.instant("Common_lblCartEmpty")
            );
        }
    }
    messageCenterClick() {
        this.router.navigate(["/messagecenter"]);
        return;
    }

    goback() {
        const path = this.router.url.split("/")[1];
        if (path == "transactionuserlists") {
            this.router.navigate(["/transactionlist"]);
            return;
        }
        if (
            Boolean(this.isBackbutton) == true &&
            this.screenDetail.mobileScreen == true
        ) {
            // this.verifyScreen(window.screen.width);
            this.gobackMenu.emit(this.screenDetail);
            this.isBackbutton = false;
        } else {
            this._location.back();
        }
    }

    callCustomerCare() {
        // this.translate.instant('Message_lblCustomerCareContactPrefix') +
        // ' <a click="preventDefault($event)" href="tel:' +
        // CountryObject.CustomerCareNumber +
        // '">' +
        // CountryObject.CustomerCareNumber +
        // '</a> ' +
        // this.translate.instant('Message_lblCustomerCareContactSuffix')
        this.modal.overlay.defaultViewContainer = this.vcRef;
        const CountryObject: any = this.geoloc.getCountryObject();
        if (
            CountryObject.CustomerCareNumber &&
            CountryObject.CustomerCareNumber != undefined
        ) {

            if (this.isWebView()) {

                ___MobileAgent___.OpenExternalLink("tel:" + CountryObject.CustomerCareNumber);

            } else {

                this.alertService.openErrorAlert(
                    this.translate.instant("Common_lblInfo"),
                    this.translate.instant("Message_lblCustomerCareContactPrefix") +
                    " " +
                    CountryObject.CustomerCareNumber +
                    " " +
                    this.translate.instant("Message_lblCustomerCareContactSuffix")
                );

            }
        } else {
            this.alertService.openErrorAlert(
                this.translate.instant("Common_lblInfo"),
                this.translate.instant("Message_customerCareError")
            );
        }
    }

    openTutorial() {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        const modalData: any = {};
        modalData.Title = this.translate.instant("Common_lblTutorial");
        modalData.URL = "";
        modalData.Action = this.translate.instant("Common_lblOk");
        // return this.modal.open(TutorialComponent, overlayConfigFactory({ modalData }, BSModalContext));
        return this.modal
            .open(
                TutorialComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe();
            });
    }
    openAboutUS(objtext) {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        // if (objtext == 'AboutUs') {
        //   modalData.Title = this.translate.instant('Common_lblAboutICE');
        // } else if (objtext == 'TermAndConditions') {
        //   modalData.Title = this.translate.instant('AppMenu_termsAndConditions');
        // } else if (objtext == 'Privacy') {
        //   modalData.Title = this.translate.instant('Common_lblPrivacyPolicy');
        // }
        if (objtext == "AboutUs") {
            modalData.Title = this.translate.instant("AboutInterCambio_title");
        } else if (objtext == "TermAndConditions") {
            modalData.Title = this.translate.instant("Common_lblTermsConditions");
        } else if (objtext == "Privacy") {
            modalData.Title = this.translate.instant("Common_lblPrivacyPolicy");
        }
        modalData.URL = objtext;
        modalData.Action = this.translate.instant("Common_lblOk");
        return this.modal
            .open(
                AboutUsComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe();
            });
    }
    openShareModal() {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        modalData.page = "menu";
        return this.modal
            .open(
                SharepromotainalPopupComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe();
            });
    }
    ngOnDestroy() {
        if (this.subModalpopup != undefined) {
            //this.subModalpopup.unsubscribe();
        }
    }

    isWebView(): boolean {
        return ___MobileAgent___.IsWrapper();
    }

    OpenICE(url: string): void {
        ___MobileAgent___.OpenICE(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/headermenu/headermenu.component.ts